import type {FC} from 'react'
import templatesData from '../../data/marketing/marketingTemplatesData'
import CombinedWorkflow from '../universal-components/combined-workflow/CombinedWorkflow'
import {useTranslation} from 'react-i18next'
import {isRunningOnKlevereDomain} from '../../../white-label/permission'

import blueDragonMarketingTemplateData from '../../../white-label/blue-dragon/marketingTemplatesData'

interface MarketingPageProps {}

const MarketingPage: FC<MarketingPageProps> = () => {
  const {t} = useTranslation()

  const title = t('common.marketing')
  const buttonColor = 'var(--marketing-workflow-btn-color)'

  let templateData: any

  if (isRunningOnKlevereDomain()) {
    templateData = templatesData
  } else {
    templateData = blueDragonMarketingTemplateData
  }

  return <CombinedWorkflow title={title} buttonColor={buttonColor} itemsData={templateData} />
}

export default MarketingPage
